<template>
  <v-link
    v-if="accessibilityMenuItem"
    class="u-desktop-only"
    :to="accessibilityMenuItem.redirectUrl"
    :aria-label="$t('common.accessibility')"
  >
    <i
      class="o-icon o-typography--action o-typography--stateful c-navbar__icon"
      :class="getIconClass(accessibilityMenuItem.icon)"
      :style="getIconStyle(accessibilityMenuItem.icon)"
    ></i>
  </v-link>
</template>

<script setup>
  import { computed } from 'vue';
  import { getIconClass, getIconStyle } from '@/shared/utils';
  import { useContext } from '@/shared/composables';
  import { VLink } from '@/index/shared/components';

  const { $services } = useContext();

  const info = $services.resolve('info');

  const accessibilityMenuItem = computed(() => info.platformSettings.accessibilityMenuItem);
</script>
